import React, { Component } from 'react'
import { Form, Col, Button, Card, Table, Jumbotron } from 'react-bootstrap';
import Menu from './menu'
import config from '../config';
import errores from '../middleware/errordb';
import funciones from '../middleware/funciones';
import Mensajes from './subcomponent/mensajes';
import Confirmcierreturno from '../components/subcomponent/confirmCerrarTurno'

export class turnos extends Component {
    constructor(props) {
        super(props);

        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            fecha: todayFormat,
            fecha_creacion: todayFormat,
            cajero: "",
            base: "",
            mostrarMensaje: false,
            empresa: currentCompany,
            tipo: currentUserType,
            vendedores: [],
            turnos: [],
            mensaje: ""
        }
    }

    componentDidMount() {
        const { fecha } = this.state;
        this.infoTurnos(fecha);
    }

    infoTurnos = (cdate) => {
        const empresaEdicion = this.state.empresa;
        if (empresaEdicion) {
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                    'hist': cdate,
                }
            }
            fetch(config.servBackEnd + '/shift/', datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        ////console.log(datos);
                        this.setState({
                            vendedores: datos[0],
                            turnos: datos[1]
                        })
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: "Debe crear un vendedor para asignar al turno" })
                    }
                });
        }
    }

    closeShift = (id) => {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/shift/closeshift/' + id, datasend).then(response => response.json())
            .then(data => {
                ;
                if (data.ok) {
                    const { fecha } = this.state;
                    this.infoTurnos(fecha);
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente" });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Debe crear un vendedor para asignar al turno" })
                }
            });
    }

    createShift = (event) => {
        event.preventDefault();
        const { fecha_creacion } = this.state
        const { cajero } = this.state
        const { base } = this.state
        const { empresa } = this.state

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA: empresa,
                FECHA: fecha_creacion,
                ID_VENDEDOR: cajero,
                BASE: base
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/shift/create/', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.infoTurnos(fecha_creacion);
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", fecha: fecha_creacion });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Error en apertura de turno: " + errores[data.code] + " " + data.message })
                }
                //this.s
                //this.setState({ data })
            });
        //});
    }
    changeDate = ({ target }) => {
        this.setState({ fecha: target.value })
        this.infoTurnos(target.value);
    }

    render() {
        const closeShift = this.closeShift;
        const { vendedores } = this.state;
        const { fecha } = this.state;
        const { turnos } = this.state;
        return (
            <div>
                <Menu></Menu>
                <Jumbotron className="Jumbotron">
                    <h2>Turnos</h2>
                </Jumbotron>
                <div>
                    <Card className="card">
                        <Card.Body>
                            <Form className="form" onSubmit={this.createShift}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="formGridFecha">
                                        <Form.Label>Fecha</Form.Label>
                                        <Form.Control type="date" placeholder="Fecha" onChange={e => this.setState({ fecha: e.target.value })} value={this.state.fecha_creacion} required disabled />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridCajero">
                                        <Form.Label>Cajero</Form.Label>
                                        <Form.Control as="select" custom="true" onChange={e => this.setState({ cajero: e.target.value })} value={this.state.cajero} required>
                                            <option value="">Seleccione</option>
                                            {
                                                vendedores.map(vendedor => {
                                                    return (<option key={vendedor.ID_VENDEDORES} value={vendedor.ID_VENDEDORES}>{vendedor.NOMBRE_VENDEDOR}</option>);
                                                })
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Base</Form.Label>
                                        <Form.Control type="number" placeholder="$" onChange={e => this.setState({ base: e.target.value })} value={this.state.base} required />
                                    </Form.Group>
                                </Form.Row>
                                <Button variant="primary" type="submit">Aperturar Turno</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
                <div className="contenedor">
                    <Form.Control type="date" onChange={this.changeDate} value={fecha} required />

                    <Table hover bordered responsive size="sm" className="table">
                        <thead>
                            <tr>
                                <th>Empresa</th>
                                <th>Fecha</th>
                                <th>Vendedor</th>
                                <th>Base</th>
                                <th>Estado</th>
                                <th>Hora Apertura</th>
                                <th colSpan="3">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {turnos.map(function (currentData, index) {
                                return <tr key={index + "d0"}>
                                    <td key={index + "d1"}>{currentData.ID_EMPRESA}</td>
                                    <td key={index + "d2"}>{funciones.formatDate(currentData.FECHA)}</td>
                                    <td key={index + "d3"}>{currentData.NOMBRE_VENDEDOR}</td>
                                    <td key={index + "d4"}>{currentData.BASE}</td>
                                    <td key={index + "d5"}>{funciones.textEstadoTurno(currentData.ESTADO)}</td>
                                    <td key={index + "d6"}>{currentData.HORA_CREACION}</td>
                                    <td key={index + "d9"}><Button size="sm" href={"/reportes/cierreturno/?" + currentData.ID_TURNOS} variant="outline-primary">Reporte</Button></td>
                                    {currentData.ESTADO === 1 && <td key={index + "d8"}><Confirmcierreturno functionClose={closeShift} data={currentData}  ></Confirmcierreturno></td>}
                                </tr>;
                            })}
                        </tbody>
                    </Table>
                </div>
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        )
    }
}



export default turnos
